import React from "react";
import { Label, Option, SelectInput } from "@streeteasy/design-system";
import { func, number, oneOf } from "prop-types";

import { STATUSES } from "../../constants";

const ListingProgressMenu = ({ listingId, onChange, onClick, status }) => {
  const inputId = `listingProgress-${listingId}`;

  return (
    <>
      <Label htmlFor={inputId}>Your Progress</Label>
      <SelectInput
        id={inputId}
        onChange={onChange}
        onClick={onClick}
        value={status}
      >
        {Object.values(STATUSES).map(({ label, value }) => (
          <Option key={value} disabled={value === "saved"} value={value}>
            {label}
          </Option>
        ))}
      </SelectInput>
    </>
  );
};

ListingProgressMenu.propTypes = {
  listingId: number.isRequired,
  onChange: func.isRequired,
  onClick: func.isRequired,
  status: oneOf(Object.values(STATUSES).map(status => status.value)).isRequired
};

export default ListingProgressMenu;
